import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetView from "./FacetView";
export default class DisjunctiveFacet extends Component {
  constructor(..._args) {
    super(..._args);

    _defineProperty(this, "itemFactory", args => this.props.itemFactory({ ...args,
      options: { ...args.options,
        isChecked: args.options.selected
      }
    }));

    _defineProperty(this, "isSelectedValue", facetProduct => {
      const filtersForThisFacet = this.props.filters.get(this.props.facet.get('key'));
      const facetProductsSelected = Immutable.Iterable.isIterable(filtersForThisFacet) ? filtersForThisFacet : Immutable.Set([filtersForThisFacet]);
      return facetProductsSelected.contains(facetProduct);
    });

    _defineProperty(this, "createNewFilters", facetProduct => this.props.filters.update(this.props.facet.get('key'), fs => fs.includes(facetProduct) ? fs.delete(facetProduct) : fs.add(facetProduct)));
  }

  render() {
    return /*#__PURE__*/React.createElement(FacetView, {
      createNewFilters: this.createNewFilters,
      displayFreeCheckbox: this.props.displayFreeCheckbox,
      facet: this.props.facet,
      facetBar: this.props.facetBar,
      filters: this.props.filters,
      hiddenFilters: this.props.hiddenFilters,
      isSelectedValue: this.isSelectedValue,
      itemFactory: this.itemFactory,
      itemType: "checkbox",
      onFacetProductClick: this.props.onFacetProductClick,
      perspective: this.props.perspective,
      stateChangeRequested: this.props.stateChangeRequested,
      FacetComponent: this.props.FacetComponent
    });
  }

}

_defineProperty(DisjunctiveFacet, "propTypes", {
  displayFreeCheckbox: PropTypes.bool,
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  facetBar: PropTypes.oneOf(['top', 'side']),
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  FacetComponent: PropTypes.func.isRequired
});